import { render, staticRenderFns } from "./invite-dialog.vue?vue&type=template&id=4783ba9c&scoped=true"
import script from "./invite-dialog.vue?vue&type=script&lang=js"
export * from "./invite-dialog.vue?vue&type=script&lang=js"
import style0 from "./invite-dialog.vue?vue&type=style&index=0&id=4783ba9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4783ba9c",
  null
  
)

export default component.exports